module.exports = __webpack_public_path__ + "static/media/Linotype.e64361ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Linotype.jpg
// module id = 78
// module chunks = 0